import { useState } from 'react';
import { ClientManagementScreen } from './ClientManagementScreen.js';
import { UserManagementScreen } from './UserManagementScreen.js';
import { TrancheManagementScreen } from './TrancheManagementScreen.js';
import { InspectorManagementScreen } from './InspectorManagementScreen.js';

export function AdminScreen() {
  const [section, setSection] = useState<'clients' | 'tranches' | 'users' | 'inspectors'>(
    'clients',
  );
  return (
    <main className="screen">
      <div className="screen__header">
        <div>
          <h2>Admin</h2>
          <p className="subtitle">Clients, feeds, users and access.</p>
        </div>
      </div>
      <div className="admin-tabs" role="tablist">
        <button
          role="tab"
          aria-selected={section === 'inspectors'}
          className={section === 'inspectors' ? 'chip chip--active' : 'chip'}
          onClick={() => setSection('inspectors')}
        >
          Inspectors
        </button>
        <button
          role="tab"
          aria-selected={section === 'clients'}
          className={section === 'clients' ? 'chip chip--active' : 'chip'}
          onClick={() => setSection('clients')}
        >
          Clients
        </button>
        <button
          role="tab"
          aria-selected={section === 'tranches'}
          className={section === 'tranches' ? 'chip chip--active' : 'chip'}
          onClick={() => setSection('tranches')}
        >
          Tranches
        </button>
        <button
          role="tab"
          aria-selected={section === 'users'}
          className={section === 'users' ? 'chip chip--active' : 'chip'}
          onClick={() => setSection('users')}
        >
          Users
        </button>
      </div>
      {section === 'clients' ? (
        <ClientManagementScreen />
      ) : section === 'tranches' ? (
        <TrancheManagementScreen />
      ) : section === 'users' ? (
        <UserManagementScreen embedded />
      ) : (
        <InspectorManagementScreen />
      )}
    </main>
  );
}
